<div class="contenedor">
    <input type="checkbox" id="toggle">
    <label for="toggle" class="button"></label>
    <nav class="nav">
      <a style="cursor: pointer;" (click)="exportarAnual()">Exportar CSV ANUAL&nbsp;<i class="far fa-file-excel"></i></a>
      <a style="cursor: pointer;" (click)="exportarMensual()">Exportar CSV MENSUAL&nbsp;<i class="far fa-file-excel"></i></a>
    </nav>
</div>